import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { handleFormError } from '@/utils/helpers.js'
import { toast } from 'sonner'

export default function useCreateTransactionCategory({
  transactionCategoryType,
  setError,
}) {
  const queryClient = useQueryClient()

  const action = async ({
    name = null,
    description = null,
    default_vault_id = null,
    transaction_category_group: {
      id = null,
      transaction_category_group_name = null,
    },
  }) => {
    return await httpClient.post(
      `/team/transaction-category/${transactionCategoryType}`,
      {
        name,
        description,
        default_vault_id,
        transaction_category_group: {
          id,
          name: transaction_category_group_name,
        },
      },
    )
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        showToast: true,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['transaction-categories', { type: transactionCategoryType }],
      })
      toast.success(`${transactionCategoryType} category successfully added`)
    },
  })

  return {
    createTransactionCategory: mutation.mutateAsync,
  }
}
